<div
  class="maxx-panel"
  [id]="panelId"
  [class.maxx-panel--error]="state.status === 'error'"
  role="region"
  [attr.aria-label]="'MAXX analysis for ' + testName"
  [attr.aria-busy]="state.status === 'loading'">
  @if (state.status === 'loading') {
    <div class="maxx-panel__loading" role="status">
      <pdq-spinner [small]="true"></pdq-spinner>
      <span class="maxx-panel__loading-text">MAXX is analyzing the latest test data…</span>
    </div>
  }

  @if (state.status === 'error') {
    <div role="alert">
      <pdq-banner
        variant="danger"
        bannerTitle="Error While Analyzing"
        [content]="errorMessage"
        [button]="state.errorRetryable ? retryLabel : ''"
        [closable]="false"
        (onButtonClick)="retry.emit()">
      </pdq-banner>
    </div>
  }

  @if (state.status !== 'loading') {
    @if (state.answer) {
      <div class="maxx-panel__header">
        <span class="maxx-panel__title">MAXX analysis</span>
        <button
          type="button"
          class="maxx-panel__chevron"
          aria-label="Collapse MAXX analysis"
          aria-expanded="true"
          [attr.aria-controls]="panelId"
          (click)="collapse.emit()">
          <svg
            class="maxx-panel__chevron-icon"
            viewBox="0 0 10 6"
            fill="currentColor"
            focusable="false"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M4.99992 0L0 5.14286L0.833319 6L5.00008 1.71412L9.16668 5.99984L10 5.14269L4.99992 0Z" />
          </svg>
        </button>
      </div>

      <div class="maxx-panel__answer" [innerHTML]="answerHtml"></div>

      @if (state.threadId) {
        <button type="button" class="maxx-panel__continue" (click)="continueInChat.emit(state.threadId)">
          <span>Continue in</span>
          <img src="assets/icons/maxx_chat.svg" alt="" class="maxx-panel__continue-logo" />
        </button>
      }
    }
  }
</div>
